import React from 'react';
import { useSlotScreenGeneratorStore } from '@store/slotScreenGeneratorStore';
import { SLOT_SCREEN_ORDER } from '@core/types/slot-screen-generator.types';
import { ScreenCard } from './ScreenCard';

export function ScreenSidebar() {
  const screens = useSlotScreenGeneratorStore(s => s.screens);
  const activeScreenId = useSlotScreenGeneratorStore(s => s.activeScreenId);
  const setActiveScreen = useSlotScreenGeneratorStore(s => s.setActiveScreen);

  return (
    <div className="w-[140px] flex-shrink-0 border-r border-zinc-800 overflow-y-auto bg-zinc-900/50 py-2">
      <div className="text-[10px] text-zinc-500 uppercase tracking-wider px-3 mb-1">Screens</div>
      {SLOT_SCREEN_ORDER.map(id => (
        <ScreenCard
          key={id}
          screen={screens[id]}
          isActive={id === activeScreenId}
          onClick={() => setActiveScreen(id)}
        />
      ))}
    </div>
  );
}
